import { useContext } from "react";
import StarekContext, { PERMISSIONS } from "../context/StarekContext";

export function usePermissions() {
    const { can, permissionMap, memberships, loadMemberships, lastUsedPlant } =
        useContext(StarekContext);
    const activePlantPerms = lastUsedPlant?.id
        ? (permissionMap?.[lastUsedPlant.id] ?? {})
        : {};

    return {
        can,
        permissionMap,
        activePlantPerms,
        memberships,
        loadMemberships,
        PERMISSIONS,
    };
}
